/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:69aefad5-a1d5-4106-a605-e6422e941686",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_WecQr6w8L",
    "aws_user_pools_web_client_id": "41pbm6r925h63a366fg0e5413i",
    "oauth": {
        "domain": "mantratax-prod.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/,https://prod.d2kms0onw2dk2t.amplifyapp.com/",
        "redirectSignOut": "http://localhost:3000/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_appsync_graphqlEndpoint": "https://cbxgzlquivbr3g5t3lg7sstt5e.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "mantratax21750-prod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
